import React, {
  useState, useContext, useMemo, useCallback, useRef,
} from 'react'
import { Box, Loader, Text } from '@usap/uicomponents'
import {
  ReturnItemContext,
  SelectedItemsContext,
  Lightbox,
} from './includes'
import {
  ImageGalleryItem,
  Diagnosis,
  FirstSelectReason,
  CommentTextArea,
  OptionsSelectItems,
} from '../ReasonsElements'
import ImgErrorMessageLb from '../../ImgErrorMessageLb'
import RMANeedHelp from '../RMANeedHelp'
import { Heading3, Heading5 } from '../../../../common/heading'
import { allowImg } from './constant'
import {
  useInitialLoad, useCheckConditionalReason, useManageStep, useResetDataAndStep,
} from './hooks'
import { manageImageChange, manageDocumentChange } from './utils'
import useGetHassleFreeFlag from '../../hooks/useGetHassleFreeFlag'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ReturnQuantitySelectionWMO from './ReturnQuantitySelectionWMO'

const RMAReturnStep = props => {
  const {
    handleReason,
    isDesktop,
    appSteps,
    setAppSteps,
    merchantOrderId,
    activeCount = 0,
    partSelection,
    setImgSteps,
    setDocSteps,
    fileUpload,
    setFileUpload,
    customerOrder,
    formFile = {},
    setFormFile,
    tempStep,
    setTempStep,
    reqElem,
    setReqElem,
    errorSteps,
    setErrorSteps,
    selectedPartETA,
    selectedPart,
    orderStatus,
    mechanicDiagnosis = [],
    OpenChatHandler,
    setReturnQuantity,
    submitSelect = false,
    buttonLabel = ""
  } = props
  const {
    reduceImageResolution, getBase64, putSignedUrl, getSteps, setUploadPayload,
  } = handleReason
  const [animate, setAnimate] = useState('fadeIn')
  const [displayImgUploadError, setDisplayImgUploadError] = useState(false)
  const [preserveReason, setPreserveReason] = useState({})
  const [imgErrorMessage, setImgErrorMessage] = useState('')
  const productImagesTypes = useMemo(() => reqElem.find(x => x.id === 'productImages') || {}, [reqElem])
  const documentLibraryTypes = useMemo(() => reqElem.find(x => x.id === 'documentLibrary') || {}, [reqElem])
  const [optionsToHide, setOptionsToHide] = useState([])
  const [noDataError, setNoDataError] = useState(false)
  const commentValueRef = useRef(undefined)

  const returnItemContext = useContext(ReturnItemContext)
  const { orderItem } = returnItemContext
  const { isHassleFree } = useGetHassleFreeFlag()
  const selectedItemsContextData = useContext(SelectedItemsContext)
  const {
    orderItems,
    applicationData,
    setSelectedImages,
    filesUpload,
    setFilesUpload,
    setSelectedDocs,
    selectedDocs,
  } = selectedItemsContextData

  const {
    data,
    setData,
    step,
    setStep,
  } = useResetDataAndStep({
    appSteps,
  })

  const selectedPartInfo = useMemo(
    () => (
      Array.isArray(orderItems) && orderItems.find(product => product.sku === selectedPart)
    )
    || {},
    [selectedPart, orderItems],
  )
  const allowMechanicDiagnosis = useMemo(
    () => mechanicDiagnosis.filter(x => x.toLowerCase() === (selectedPartInfo.part_name || '').toLowerCase()).length > 0,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedPartInfo],
  )
  const displayRMAHelp = useMemo(() => step === 'wrongItem' || step === 'itemDefective' || step === 'itemMissing',
    [step])

  orderItem.displayChatBubble = displayRMAHelp

  const showErrorMessage = () => {
    setTimeout(() => {
      setDisplayImgUploadError(false)
    }, 5000)
  }

  const checkConditionalReason = useCheckConditionalReason({
    activeCount,
    partSelection,
    selectedPartInfo,
    merchantOrderId,
    setPreserveReason,
    setOptionsToHide,
    setData,
    allowMechanicDiagnosis,
    selectedPartETA,
    isHassleFree,
  })

  const oidIndex = useCallback(
    skuData => orderItems.findIndex(product => product.sku === skuData),
    [orderItems],
  )

  const { loadingData } = useManageStep({
    orderItems,
    oidIndex,
    step,
    customerOrder,
    getSteps,
    setReqElem,
    setNoDataError,
    checkConditionalReason,
    setData,
    setStep,
    selectedPart,
  })

  const removedReqSel = wids => {
    if (reqElem && reqElem.length) {
      const arrReqElem = [reqElem]
      let idxremoved = -1
      arrReqElem[0].forEach(({ id }, indx) => {
        if (wids === id) {
          idxremoved = indx
        }
      })
      if (idxremoved !== -1) {
        arrReqElem[0].splice(idxremoved, 1)
        setReqElem(arrReqElem[0])
      }
    }
    delete errorSteps[`${wids}`]
  }

  /* removed same type of reason */
  const removedExistingParentId = wid => {
    const arrSteps = [appSteps]
    let index = -1
    arrSteps[0].forEach(({ parent }, cntIndx) => {
      if (wid === parent) {
        index = cntIndx
      }
    })

    if (index !== -1) {
      arrSteps[0].splice(index, 1)
      setAppSteps(arrSteps[0])
    }
  }

  const hideAllSubReasonForWrongItemReceived = selected => {
    if (selected !== 'differentSide' && selected !== 'differentPart' && selected !== 'partDoesNotFit') {
      removedReqSel(preserveReason)
      return []
    }

    const tempAppSteps = appSteps
    const optionsToHideTemp = []
    // Remove previously selected Reason
    if (tempAppSteps[2]
        && tempAppSteps[2].id !== 'differentSide'
        && tempAppSteps[2].id !== 'differentPart'
        && tempAppSteps[2].id !== 'partDoesNotFit'
    ) {
      tempAppSteps.pop()
      setAppSteps(tempAppSteps)
    }
    // Hide temporarily all choices for 3rd reason
    const subReasonClass = document.querySelectorAll(`.${preserveReason}-options`)
    let i = 0
    const l = subReasonClass.length

    for (i; i < l; i += 1) {
      optionsToHideTemp.push(subReasonClass[parseInt(i, 10)].id)
    }
    setOptionsToHide(optionsToHideTemp)
    return optionsToHideTemp
  }

  const getSubReasonForItemDefective = (selected, orderItemData) => {
    const optionsToHideTemp = []
    const tempAppSteps = appSteps
    switch (selected) {
      case 'defectiveUponInstallation':
      case 'describeOtherDefectiveCase':
        if (selected === 'defectiveUponInstallation' && orderItemData.part_name !== 'Catalytic Converter') {
          if (orderItemData.appFits === '') {
            setReqElem([...reqElem, { id: preserveReason[1], type: 'optionSelect' }])
            optionsToHideTemp.push(preserveReason[0])
            removedReqSel(preserveReason[0])
          } else {
            const hasDuplicateOptions = reqElem.filter((ele) => (ele.id === preserveReason[0]))
            if(!hasDuplicateOptions?.length) {
              setReqElem([...reqElem, { id: preserveReason[0], type: 'optionSelect' }])
            }
            optionsToHideTemp.push(preserveReason[1])
            removedReqSel(preserveReason[1])
          }
        } else {
          optionsToHideTemp.push(preserveReason[0])
          optionsToHideTemp.push(preserveReason[1])
          removedReqSel(preserveReason[0])
          removedReqSel(preserveReason[1])
        }
        // Remove selected in the 3rd/4th sub reason (if any)
        if (tempAppSteps[2]
            && (tempAppSteps[2].parent === 'howCanWeHelpToResolve'
                || tempAppSteps[2].parent === 'howToShipTheItem')
        ) {
          tempAppSteps.pop()
          setAppSteps(tempAppSteps)
        }
        setOptionsToHide(optionsToHideTemp)
        break
      case 'productWorkedButBecameDefective':
        // Remove selected in the 3rd/4th sub reason (if any)
        if (tempAppSteps[2]
            && (tempAppSteps[2].parent === 'howCanWeHelpToResolve'
                || tempAppSteps[2].parent === 'howToShipTheItem')
        ) {
          tempAppSteps.pop()
          setAppSteps(tempAppSteps)
        }

        optionsToHideTemp.push(preserveReason[0])
        optionsToHideTemp.push(preserveReason[1])
        removedReqSel(preserveReason[0])
        removedReqSel(preserveReason[1])
        setOptionsToHide(optionsToHideTemp)
        break
      default:
        break
    }
  }

  const getSubReasonForWrongItemReceived = (selected, orderItemData) => {
    // Determine which to display
    if (selected === 'differentSide' || selected === 'differentPart' || selected === 'partDoesNotFit') {
      setReqElem([...reqElem, { id: preserveReason, type: 'optionSelect' }])
    }
    const optionsToHideTemp = hideAllSubReasonForWrongItemReceived(selected)
    switch (selected) {
      case 'differentSide':
      case 'differentPart':
        optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-returnPartsAlreadyReceived`), 1)
        optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-replaceIncorrectPartReceived`), 1)
        setOptionsToHide(optionsToHideTemp)
        return true
      case 'partDoesNotFit':
        if (orderItemData.appFits === '1') {
          optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-replaceIncorrectPartReceived`), 1)
          optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-returnPartsAlreadyReceived`), 1)
          setOptionsToHide(optionsToHideTemp)
        } else {
          optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-sendPrepaidShippingLabel`), 1)
          optionsToHideTemp.splice(optionsToHideTemp.findIndex(nameId => nameId === `${preserveReason}-fullRefund`), 1)
          setOptionsToHide(optionsToHideTemp)
        }
        return true
      default:
        return true
    }
  }

  const stepHandler = (widget, value, label, sku) => {
    removedReqSel(widget.id)

    // Display necessary 3rd Sub Reason for Wrong Item Received
    if (widget.parent === 'wrongItem') {
      getSubReasonForWrongItemReceived(value, orderItems[`${oidIndex(sku)}`])
    }

    // Display necessary 3rd Sub Reason for Part was Defective
    if (widget.parent === 'itemDefective') {
      getSubReasonForItemDefective(value, orderItems[`${oidIndex(sku)}`])
    }

    let newValues = {
      title: widget.title,
      parent: widget.id,
      id: value,
      label,
    }

    if (appSteps && widget.id !== 'mainReason') {
      removedExistingParentId(widget.id)
      setAppSteps([...appSteps, newValues])
      /**
       * Specific condition for Warranty Claim
       * Instead of a single step, it will generate another step for the mainReason
       * you may check the payloadData variable in the RMAReturnDetails.js
       */
      if (step === 'warrantyClaim') {
        newValues = {
          title: step,
          parent: widget.id,
          id: step,
          label,
        }
      }
      orderItems[`${oidIndex(sku)}`].reasons = [...appSteps, newValues]
    } else {
      setAppSteps([newValues])
      orderItems[`${oidIndex(sku)}`].reasons = [newValues]
      setAnimate('fadeIn')
    }
    setTempStep([])

    if (widget.id === 'mainReason') {
      setStep(value)
    }
  }

  const onImageChange = async event => {
    await manageImageChange({
      event,
      setImgErrorMessage,
      setDisplayImgUploadError,
      showErrorMessage,
      formFile,
      allowImg,
      reduceImageResolution,
      getBase64,
      setImgSteps,
      removedReqSel,
      setReqElem,
      orderItems,
      oidIndex,
      productImagesTypes,
      setUploadPayload,
      putSignedUrl,
      applicationData,
      setSelectedImages,
      setFilesUpload,
      setFormFile,
      fileUpload,
      filesUpload,
      setFileUpload,
    })
  }

  const onDocumentChange = async event => {
    await manageDocumentChange({
      event,
      setImgErrorMessage,
      setDisplayImgUploadError,
      showErrorMessage,
      allowImg,
      getBase64,
      reduceImageResolution,
      setDocSteps,
      removedReqSel,
      setReqElem,
      documentLibraryTypes,
      orderItems,
      oidIndex,
      setUploadPayload,
      putSignedUrl,
      applicationData,
      fileUpload,
      setSelectedDocs,
      selectedDocs,
      setFilesUpload,
      filesUpload,
      formFile,
      setFormFile,
      setFileUpload,
    })
  }

  const skuIndex = useCallback(
    (skuID, imgID) => {
      const { images } = orderItems[`${oidIndex(skuID)}`]
      const imgLocataion = images.findIndex(img => img.id === imgID)
      images.splice(imgLocataion, 1)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [orderItems],
  )

  const removeImage = (target, widgets, skuID) => {
    const tempFormFile = { ...formFile }
    delete tempFormFile[`${target}`]
    setFormFile(tempFormFile)
    /* removed id information on context */
    skuIndex(skuID, target)

    const tmpImages = filesUpload
    delete tmpImages[`${skuID}`][`${target}`]
    setFilesUpload(tmpImages)

    setFileUpload(prev => ({ ...prev, [target]: undefined }))
    setImgSteps(prev => {
      const updateSteps = {
        ...prev,
        [skuID]: [
          ...prev[`${skuID}`].filter(x => x.id !== target) || [],
        ],
      }

      if ((updateSteps[`${skuID}`] || []).length >= 1 || !widgets.required) {
        removedReqSel('productImages')
      } else if ((updateSteps[`${skuID}`] || []).length < 1 && widgets.required) {
        setReqElem(prev2 => [...prev2.filter(x => x.id !== 'productImages'), productImagesTypes])
      }

      return updateSteps
    })
    return true
  }

  const removeDocument = (target, widgets, skuID) => {
    const tempFormFile = { ...formFile }
    delete tempFormFile[`${target}`]
    setFormFile(tempFormFile)
    /* removed id information on context */
    skuIndex(skuID, target)

    const docs = filesUpload
    delete docs[`${skuID}`][`${target}`]
    setFilesUpload(docs)

    setFileUpload(prev => ({ ...prev, [target]: undefined }))
    setDocSteps(prev => {
      const updateSteps = {
        ...prev,
        [skuID]: [
          ...prev[`${skuID}`].filter(x => x.id !== target) || [],
        ],
      }

      orderItems[`${oidIndex(skuID)}`].documents = (orderItems[`${oidIndex(skuID)}`].documents || []).filter(x => x.id !== target)

      if ((updateSteps[`${skuID}`] || []).length >= 3 || !widgets.required) {
        removedReqSel('documentLibrary')
      } else if ((updateSteps[`${skuID}`] || []).length < 3 && widgets.required) {
        setReqElem(prev2 => [...prev2.filter(x => x.id !== 'documentLibrary'), documentLibraryTypes])
      }

      return updateSteps
    })

    return true
  }

  const removeAllImage = () => {
    setFormFile({})
    setFileUpload({})

    return true
  }

  useInitialLoad(removeAllImage)

  const setCheckedSelected = paramValue => {
    let isChecked = false
    if (appSteps && appSteps.length !== 0) {
      const arrayData = [appSteps]
      let resultReturn = false
      arrayData[0].forEach(({ id }) => {
        if (id.length !== 0 && id === paramValue) {
          resultReturn = true
        }
      })
      isChecked = resultReturn
    }
    if (!isChecked && tempStep && tempStep[0]) {
      isChecked = tempStep[0].id === paramValue
    }
    return isChecked
  }

  const changePrevReasons = () => {
    const arrSteps = [appSteps]
    arrSteps[0].splice(1)
    setAppSteps([])
    setTempStep(arrSteps[0])
    setErrorSteps([])
    setFormFile({})
    setFileUpload({})
  }

  const onChangeReason = () => {
    setAnimate('fadeOut')
    setStep('')
    setImgSteps({})
    setDocSteps({})
    changePrevReasons()
    setOptionsToHide([])
    setAnimate('fadeIn')
    if (step === 'warrantyClaim') {
      setTempStep([])
    }
  }

  const isWmoEnabled = useWmoEnabled()

  return (
    <>
      {loadingData && <Loader />}
      <Lightbox isDisplay={displayImgUploadError}>
        <ImgErrorMessageLb
          imgErrorMessage={imgErrorMessage}
          setDisplayImgUploadError={setDisplayImgUploadError}
        />
      </Lightbox>

      {isWmoEnabled && partSelection?.length > 0 && 
        partSelection.map((part, key) => {
          const isSelectedPart = selectedPart === part?.sku;
          if(isSelectedPart) {
            return (
              <ReturnQuantitySelectionWMO
                selectedPart={selectedPart}
                setReturnQuantity={setReturnQuantity}
                parts={part}
                ikey={key}
                submitSelect={submitSelect}
                buttonLabel={buttonLabel}
                orderItems={orderItems}
              />
            )
          }
        })
      }
      { step === 'warrantyClaim' && (
        <Box>
          <Heading3 title={data.title} margin={{ vertical: '10px' }} style={{ marginTop: isWmoEnabled && "0px"}} />
          <Text size="small" margin={{ bottom: '10px' }}>
            { data.description }
          </Text>
        </Box>
      )}
      {appSteps && appSteps[0] && (
        <FirstSelectReason
          key="selectedReasonOption"
          onChangeReason={onChangeReason}
          isDesktop={isDesktop}
          firstStep={appSteps[0]}
        />
      )}
      {data && data.widgets
        ? data.widgets.map(widgets => (
          <Box
            width={isWmoEnabled ? "100%" : "large"}
            alignContent="center"
            alignSelf="center"
            animation={animate}
            key={`RMAReturnSteps-box-${widgets.id}`}
          >
            {widgets.type === 'optionSelect' && (
              <OptionsSelectItems
                key={`${widgets.id}-options`}
                selectedPart={selectedPart}
                widgets={widgets}
                appSteps={appSteps}
                primaryStep={step}
                optionsToHide={optionsToHide}
                setCheckedSelected={setCheckedSelected}
                stepHandler={stepHandler}
                isDesktop={isDesktop}
                errorSteps={errorSteps}
                selectedPartETA={selectedPartInfo.ETA || null}
                orderStatus={orderStatus}
                orderItems={orderItems}
              />
            )}

            {widgets.type === 'imageGallery' && (
              <ImageGalleryItem
                key={`${widgets.id}-images`}
                selectedPart={selectedPart}
                widgets={widgets}
                onChange={onImageChange}
                removeImage={removeImage}
                formFile={formFile}
                isDesktop={isDesktop}
                errorSteps={errorSteps}
              />
            )}

            { widgets.type === 'documentLibrary' && allowMechanicDiagnosis && (
              <Diagnosis
                selectedPart={selectedPart}
                widget={widgets}
                errorSteps={errorSteps}
                formFile={formFile}
                onChange={onDocumentChange}
                removeDocument={removeDocument}
                isDesktop={isDesktop}
              />
            ) }

            {widgets.type === 'textarea' && (
              <CommentTextArea
                key={`${widgets.id}-comment`}
                selectedPart={selectedPart}
                isDesktop={isDesktop}
                widgets={widgets}
                errorSteps={errorSteps}
                removedReqSel={removedReqSel}
                reqElem={reqElem}
                setReqElem={setReqElem}
                commentValueRef={commentValueRef}
              />
            )}
          </Box>
        ))
        : (
          <>
            {noDataError && (
              <Lightbox isDisplay>
                <ImgErrorMessageLb
                  imgErrorMessage={noDataError}
                  setDisplayImgUploadError={setNoDataError}
                />

              </Lightbox>
            )}
            <Heading5
              width="large"
              key="errorMessage"
              title="No data found for return part reasons"
              size={isDesktop ? 'medium' : 'small'}
              color="black"
              style={{
                fontSize: '14px',
                fontWeight: 700,
                maxWidth: '100%',
                textAlign: 'center',
              }}
              margin={{ bottom: '8px', top: '15px' }}
            />
          </>
        )}
      { displayRMAHelp && (
        <RMANeedHelp OpenChatHandler={OpenChatHandler} />
      )}
    </>
  )
}

export default RMAReturnStep
